var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9415_249",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9415_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18H14.5C14.7833 18 15.0458 17.9292 15.2875 17.7875C15.5292 17.6458 15.7 17.45 15.8 17.2L17.9 12.3C17.9333 12.2167 17.9583 12.1333 17.975 12.05C17.9917 11.9667 18 11.8833 18 11.8V11C18 10.7167 17.9042 10.4792 17.7125 10.2875C17.5208 10.0958 17.2833 10 17 10H12.4L13 6.6C13.0333 6.43333 13.025 6.275 12.975 6.125C12.925 5.975 12.8417 5.84167 12.725 5.725L12 5L7.4 10C7.26667 10.1333 7.16667 10.2833 7.1 10.45C7.03333 10.6167 7 10.8 7 11V16C7 16.55 7.19583 17.0208 7.5875 17.4125C7.97917 17.8042 8.45 18 9 18ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
    fill: "#1C82D8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommend);
export default __webpack_public_path__ + "static/media/recommend.f90fddc80654b3daa853d5a22cd3dadc.svg";
export { ForwardRef as ReactComponent };